// extracted by mini-css-extract-plugin
module.exports = {"dark":"dark_dark__2RILS"};